import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Dimmer, Loader } from "semantic-ui-react";
import Layout from "../../hoc/Layout";
import catchErrors from "../../helpers/catchErrors";
import { readMyEvents } from "../../helpers/events";
import EventListPrivate from "../../components/Events/EventsListPrivate";

function MyEvents() {
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { user } = useSelector((state) => ({ ...state }));

  useEffect(() => {
    setLoading(true);
    const response = async () => {
      try {
        const userToken = user.token;

        const response = await readMyEvents(userToken);
        setData(response.data);
        setLoading(false);
      } catch (error) {
        catchErrors(error, setError);
      }
    };
    return response();
  }, []);

  return (
    <Layout>
      <div className="createImage"></div>
      <div className="home">
        <div className="content">
          <h2 className="secTitle">My Events</h2>
          {loading ? (
            <>
              {" "}
              <Dimmer active inverted>
                <Loader size="massive">Loading...</Loader>
              </Dimmer>
            </>
          ) : (
            <>
              <EventListPrivate data={data} />
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default MyEvents;
